module.exports = [{"type":"title","text":"2025-07-09"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"USDT-M Perp Futures: Removed SNAPSHOT type from 'Account balance and position update push'."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2025-07-09.json
// module id = FF3k
// module chunks = 3